import React, {useCallback, useEffect, useState} from "react";
import Layout from "../layout/Layout";
import BasicText from "../../../components/form-v2/basic-text";
import {BlueButton} from "../../../components/ui/Buttons";
import {useNavigate, useParams} from "react-router-dom";
import LoadingSpinner from "../../../components/ui/LoadingSpinner";
import {ToggleButton} from "../import/inputs";
import {PhoneInput} from "../../../components/form-v2/phone-input/PhoneInput";
import {useDepartment, useUpdateDepartment} from "../../../api/platform/useDepartments";
import {ErrorBox} from "../../../components/ui/ErrorBox";


const DepartmentEdit: React.FC = () => {

    const {id} = useParams();
    const navigate = useNavigate();

    const departmentQuery = useDepartment(id ?? "");
    const updateMutation = useUpdateDepartment(id ?? "");

    const department = departmentQuery.data;

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [receiveEmailNotifications, setReceiveEmailNotifications] = useState(false);

    useEffect(() => {
        if (!department) return;
        setName(department.name);
        setEmail(department.alertConfig?.emailAddress ?? "");
        setPhone(department.alertConfig?.emergencyPhoneNumber ?? "");
        setReceiveEmailNotifications(department.receiveEmailNotifications);
    }, [department]);

    const save = useCallback(() => {
        updateMutation.mutate(
            { name, email, phone, receiveEmailNotifications },
            {
                onSuccess: () => {
                    const params = new URLSearchParams();
                    params.set("message", "department has been updated");
                    navigate(`/management/departments?${params.toString()}`);
                },
            },
        );
    }, [name, email, phone, receiveEmailNotifications]);

    return <Layout
        active={"departments"}
    >

        <div className="flex flex-col gap-8">
            {departmentQuery.isLoading && <div className="bg-white shadow-md p-4 w-1/2 flex flex-col gap-8 items-center">
                <LoadingSpinner/>
            </div>}
            {departmentQuery.isError && <p className="text-red">Error loading department</p>}
            {department && (() => {
                const fieldErrors = updateMutation.error?.errors;
                return (
                    <div className="bg-white shadow-md p-4 w-1/2 flex flex-col gap-8">
                        <p className="text-md text-left pb-2 font-semibold">Edit Department</p>
                        <div className="flex flex-col gap-1">
                            <BasicText value={name} onChange={setName} label="Name"/>
                            {fieldErrors?.name?.map((e, i) => <p key={i} className="text-red text-sm">{e}</p>)}
                        </div>
                        <div className="flex flex-col gap-1">
                            <BasicText value={email} onChange={setEmail} label="Email"/>
                            {fieldErrors?.email?.map((e, i) => <p key={i} className="text-red text-sm">{e}</p>)}
                        </div>
                        <ToggleButton text={"Receive Email Notifications"} initialValue={department.receiveEmailNotifications} onChange={setReceiveEmailNotifications} />
                        <div className="flex flex-col gap-1">
                            <PhoneInput onChange={setPhone} label="Phone" initialValue={department.alertConfig?.emergencyPhoneNumber ?? ""} />
                            {fieldErrors?.phone?.map((e, i) => <p key={i} className="text-red text-sm">{e}</p>)}
                        </div>
                        <BlueButton text={"Update Department"} disabled={name === ""} onClick={save} loading={updateMutation.isLoading}/>
                        <ErrorBox error={updateMutation.error} />
                    </div>
                );
            })()}
        </div>

    </Layout>

}

DepartmentEdit.displayName = "DepartmentEdit";

export default DepartmentEdit;